import React, {useEffect, useState} from 'react'
import './Piechatcard.css'
import {IoDownloadOutline} from 'react-icons/io5'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { FaRegThumbsUp } from 'react-icons/fa';

const Submittedcard = () => {
  const [percentage, setPercentage] = useState(0)

  useEffect(() => {
    handleWidth()
  }, [])

  const handleWidth = () =>{
    setPercentage(75)
  }

  return (
    <div className='Performancecard-container'>
        <div className='Performancecard-top'>
            <span>Submitted Appraisals</span>
            <span><IoDownloadOutline id='perf-icon'/></span>
        </div>
        <div className='Performancecard-bottms'>
          <CircularProgressbar 
            value={percentage}  
            text={`${percentage}%`} 
            circleRatio={0.6} 
            strokeWidth={12}
            styles={{
              path: {
                stroke: `rgba(255, 92, 0, ${percentage / 100})`,
                strokeLinecap: "butt",
                transition: 'stroke-dashoffset 1.5s ease 0s',
                transform: 'rotate(0.70turn)',
                transformOrigin: 'center center',
              },
              trail: {
                // stroke: "white",
                stroke: '#d5d5d5',
                strokeLinecap: "butt",
                transform: 'rotate(0.70turn)',
                transformOrigin: 'center center',
              }, 
              text: {
                fill: "#828181",
                fontSize: '12px',
                fontWeight: '500',
                fontFamily: 'Fira Sans Condensed, sans-serif'
              },
              background: {
                fill: '#3e98c7',
              }
              
            }}
          />
          <FaRegThumbsUp id='id-piearrowid'/>
        </div>
    </div>
  )
}

export default Submittedcard